// removed by extract-text-webpack-plugin
module.exports = {"pointer":"_1c96bgv7bBca2VokrFo3eS_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-495b58f6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/SettingTargetObjTree.vue
// module id = l2cT
// module chunks = 75